module.exports = __webpack_public_path__ + "static/img/section03-02@m.0252e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/omron-healthcare/section03-02@m.jpg
// module id = 8OCJ
// module chunks = 0